export const ApiQueryKey = {
	admins: 'admins',

	attributes: 'attributes',
	attributeValues: 'attribute-values',

	creatorProductModules: 'creator-product-modules',
	projects: 'projects',
	presets: 'presets',

	content: 'content',

	productModules: 'product-modules',
	productModulesCategories: 'product-module-categories',
	landscapeModules: 'landscape-modules',
	assets: 'assets',
	roles: 'roles',
	merchants: 'merchants',
} as const;

export type ApiQueryKey = (typeof ApiQueryKey)[keyof typeof ApiQueryKey];
